import { Temporal } from '@js-temporal/polyfill'
import { z } from 'zod'
import { useParsedStorage } from '../../../../core'

const ANNOUNCEMENT_VIEWER_COOKIE_NAME = 'joyful-announcement-viewer'
const MAX_DISMISSED_ANNOUNCEMENT_IDS = 50
const AnnouncementViewerStateSchema = z.object({
  dismissedIds: z.array(z.uuid()),
  lastSeenDate: z.iso.date().nullable(),
})
const EmptyAnnouncementViewerState: z.infer<
  typeof AnnouncementViewerStateSchema
> = {
  dismissedIds: [],
  lastSeenDate: null,
}

export function useUnseenAnnouncements() {
  const [viewerState, setViewerState] = useParsedStorage(
    ANNOUNCEMENT_VIEWER_COOKIE_NAME,
    {
      cookie: {
        domain: getJoyfulParentCookieDomain(),
      },
      initialValue: EmptyAnnouncementViewerState,
      schema: AnnouncementViewerStateSchema,
      strategy: 'cookie',
    },
  )

  const dismissAnnouncement = (announcementId: string) => {
    setViewerState((current) => {
      if (current.dismissedIds.includes(announcementId)) {
        return current
      }

      return {
        ...current,
        dismissedIds: [...current.dismissedIds, announcementId].slice(
          -MAX_DISMISSED_ANNOUNCEMENT_IDS,
        ),
      }
    })
  }

  const markSeen = () => {
    const lastSeenDate =
      Temporal.Now.plainDateISO('America/New_York').toString()
    setViewerState((current) => {
      return {
        ...current,
        lastSeenDate,
      }
    })
  }

  return {
    dismissAnnouncement,
    dismissedIds: viewerState.dismissedIds,
    lastSeenDate: viewerState.lastSeenDate,
    markSeen,
  }
}

function getJoyfulParentCookieDomain() {
  const { hostname } = globalThis.location
  if (
    hostname === 'joyfulhealth.com' ||
    hostname.endsWith('.joyfulhealth.com')
  ) {
    return '.joyfulhealth.com'
  }

  if (hostname === 'joyfulhealth.io' || hostname.endsWith('.joyfulhealth.io')) {
    return '.joyfulhealth.io'
  }

  return undefined
}
